module.exports = __webpack_public_path__ + "/images/shop/icon/quick_view.svg";